<template>
  <va-create-layout>
    <department-form :title="title" :item="item"></department-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
